import React from 'react';
import PropTypes from 'prop-types';

import SectionHeader from 'Components/SectionHeader';
import FlashMessage from 'Components/FlashMessage';

import styles from './ListPageHeader.scss';

class ListPageHeader extends React.PureComponent {
  render() {
    const {
      pageTitle,
      headerActionButton,
      tabSwitcher,
      type,
      message,
      listTableHeader,
      isSticky,
    } = this.props;
    return (
      <div
        className={`ListPageHeader ListPageHeader--${type}${
          isSticky ? ' ListPageHeader--sticky' : ''
        }`}
      >
        <div className="ListPageHeader__container">
          <SectionHeader
            title={pageTitle}
            type="page-header"
            actionButton={headerActionButton}
          />
          {message ? (
            <FlashMessage
              {...message}
              animationType="fade"
              location="users-page-header"
            />
          ) : null}
          {tabSwitcher}
        </div>
        <div className="ListPageHeader__table-header" data-type={type}>
          <div className="ListPageHeader__table-header-container">
            {listTableHeader}
          </div>
        </div>
      </div>
    );
  }
}

ListPageHeader.propTypes = {
  pageTitle: PropTypes.node,
  headerActionButton: PropTypes.element,
  tabSwitcher: PropTypes.element,
  type: PropTypes.string,
  message: PropTypes.object,
  listTableHeader: PropTypes.element,
  isSticky: PropTypes.bool,
};

ListPageHeader.defaultProps = {
  type: 'users',
  isSticky: false,
};

export default ListPageHeader;
